import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Tooltip from '@/components/Tooltip';
import { classes, isActive, styles } from './utils';

export type SidebarButtonProps = {
  href: string;
  label: string;
  icon: ReactNode;
  color?: string;
  bgColor?: string;
};

export default function SidebarButton({
  href,
  label,
  icon,
  color,
  bgColor,
}: SidebarButtonProps) {
  const pathname = usePathname();
  const isButtonActive = isActive(href, pathname);
  const hasCustomColor = isButtonActive && !!bgColor;

  let stateClass = classes.inactive;
  if (isButtonActive) {
    stateClass = hasCustomColor ? classes.activeCustom : classes.active;
  }

  return (
    <Tooltip arrow title={label} enterDelay={0} placement="right">
      <Link
        style={hasCustomColor ? styles.active(color, bgColor) : undefined}
        className={twMerge(classes.button, stateClass)}
        href={href}>
        <span className={classes.icon}>{icon}</span>
      </Link>
    </Tooltip>
  );
}
